export default "__VITE_ASSET__B7HjsFM1__"